/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var e,T,i;!function(e){e[e.OBJECT=0]="OBJECT",e[e.ENTITY=1]="ENTITY",e[e.RELATIONSHIP=2]="RELATIONSHIP",e[e.PATH=3]="PATH",e[e.ARRAY=4]="ARRAY"}(e||(e={})),function(e){e[e.view=0]="view",e[e.edit=1]="edit"}(T||(T={})),function(e){e[e.exclude=0]="exclude",e[e.include=1]="include"}(i||(i={}));export{e as WasmGraphQueryResponseTypeCodes,i as WasmProvenanceBehaviorValues,T as WasmQuantizeModeCodes};
